const PageLoading = () => {
    return (
        <div className="loader-container">
          <div className="loader">
            <style>
              {`
                .loader-container {
                  background-color: #090a10; /* color de fondo oscuro */
                  display: flex; /* centra el contenido */
                  flex-direction: column; /* coloca el texto debajo del loading */
                  align-items: center;
                  justify-content: center;
                  height: 100vh; /* ocupa toda la pantalla */
                  width: 100vw;
                }
    
                .loader {
                  border: 16px solid #141725; /* color del borde */
                  border-top: 16px solid #18d26e; /* color de la carga */
                  border-radius: 50%; /* redondea las esquinas */
                  width: 120px; /* tamaño del loading */
                  height: 120px;
                  animation: spin 2s linear infinite; /* animación de giro */
                }
    
                .loader-text {
                  font-size: 35px; /* tamaño de la fuente */
                  font-family: "Poppins", sans-serif;
                  color: #18d26e; /* color del texto */
                  margin-top: 16px; /* espacio entre el loading y el texto */
                  animation: fade 2s ease-in-out infinite; /* animación de entrada */
                }
    
                @keyframes fade {
                  0% { opacity: 1; }
                  50% { opacity: 0; }
                  100% { opacity: 1; }
                }
    
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
          </div>
          <div className="loader-text">Cargando...</div>
        </div>
    );
};

export default PageLoading;